// Useful for getting svg icons
// https://iconsvg.xyz/

export default {
  linkNewPage(onclick) {
    const div = `
   <svg
   ${onclick ? `onclick="${onclick}"` : ''}
   xmlns="http://www.w3.org/2000/svg" fill="none"
   viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
     <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
    </svg>
    `;

    return U.createHTMLElementFromString(div);
  },
  loadingBtn(btnID) {
    const div = `
        <svg id="${btnID}_loading" class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>;
         `;
    return U.createHTMLElementFromString(div);
  },
  eyeClosed() {
    const div = `
        <svg id"eyeSVG" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88" />
        </svg>

        `;
    return U.createHTMLElementFromString(div);
  },
  detail() {
    const div = `
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
      <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
    </svg>
    `;
    return U.createHTMLElementFromString(div);
  },
  eye() {
    const div = `
        <svg id"eyeClosedSVG" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
        </svg>
        `;
    return U.createHTMLElementFromString(div);
  },
  search() {
    const div = `
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
      <path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
    </svg>

    `;
    return U.createHTMLElementFromString(div);
  },
  plus() {
    const div = `
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
      <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
    </svg>`;
    return U.createHTMLElementFromString(div);
  },
  tickCircle() {
    const div = `
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
      <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
    </svg>

    `;
    return U.createHTMLElementFromString(div);
  },
  tick() {
    const div = `
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
      <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
    </svg>
    `;
    return U.createHTMLElementFromString(div);
  },
  crossCircle() {
    const div = `
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
      <path stroke-linecap="round" stroke-linejoin="round" d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
    </svg>
    `;
    return U.createHTMLElementFromString(div);
  },
  cross(onclick) {
    const div = `
    <svg
      ${onclick ? `onclick="${onclick}"` : ''}
    xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
      <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
    </svg>
    `;
    return U.createHTMLElementFromString(div);
  },
  trash(onclick, title) {
    const titleAttr = title ? ` title="${title}"` : '';
    const onclickAttr = onclick ? ` onclick="${onclick}"` : '';
    const div = `
    <span class="inline-flex cursor-pointer"${titleAttr}${onclickAttr}>
      <svg
        xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
      </svg>
    </span>`;

    return U.createHTMLElementFromString(div);
  },
  repeat() {
    const div = `
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
      <path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
    </svg>`;
    return U.createHTMLElementFromString(div);
  },
  replaceRecycle(onclick, title) {
    const titleAttr = title ? ` title="${title}"` : '';
    const onclickAttr = onclick ? ` onclick="${onclick}"` : '';
    const div = `
    <span class="inline-flex cursor-pointer"${titleAttr}${onclickAttr}>
      <svg
        xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
      </svg>
    </span>`;
    return U.createHTMLElementFromString(div);
  },
  chevronUp(elID) {
    const div = `
    <svg
    ${elID ? `id="${elID}"` : ''}
    xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
      <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 15.75 7.5-7.5 7.5 7.5" />
    </svg>
    `;
    return U.createHTMLElementFromString(div);
  },
  edit(onclick) {
    const div = `
    <svg
    ${onclick ? `onclick="${onclick}"` : ''}
    xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
      <path stroke-linecap="round" stroke-linejoin="round" d="M15 3 21 9 9 21 3 21 3 15z" />
      <path stroke-linecap="round" stroke-linejoin="round" d="M15 3 21 9 9 21 3 21 3 15z" />
    </svg>
    `;
    return U.createHTMLElementFromString(div);
  },
  download(onclick) {
    const div = `
      <svg
        ${onclick ? `onclick="${onclick}"` : ''}
        xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 15v4c0 1.1.9 2 2 2h14a2 2 0 0 0 2-2v-4M17 9l-5 5-5-5M12 12.8V2.5"/>
      </svg>
    `;
    return U.createHTMLElementFromString(div);
  },
  uploadCloud(onclick) {
    const div = `
      <svg
        ${onclick ? `onclick="${onclick}"` : ''}
        xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21.2 15c.7-1.2 1-2.5.7-3.9-.6-2-2.4-3.5-4.4-3.5h-1.2c-.7-3-3.2-5.2-6.2-5.6-3-.3-5.9 1.3-7.3 4-1.2 2.5-1 6.5.5 8.8m8.7-1.6V21"/><path d="M16 16l-4-4-4 4"/>
      </svg>
    `;
    return U.createHTMLElementFromString(div);
  },
  magicWand(onclick) {
    const div = `
      <svg
        ${onclick ? `onclick="${onclick}"` : ''}
        xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 cursor-pointer text-primary hover:text-secondary">
        <path stroke-linecap="round" stroke-linejoin="round" d="M15.042 21.672 13.684 16.6m0 0-2.51 2.225.569-9.47 5.227 7.917-3.286-.672ZM12 2.25V4.5m5.834.166-1.591 1.591M20.25 10.5H18M7.757 14.743l-1.59 1.59M6 10.5H3.75m4.007-4.243-1.59-1.59" />
      </svg>
    `;
    return U.createHTMLElementFromString(div);
  },
  locked(onclick) {
    const div = `
      <svg
        ${onclick ? `onclick="${onclick}"` : ''}
        width="40" height="40" viewBox="0 0 24 24" fill="#343C54" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.5 16C10.5 15.1716 11.1716 14.5 12 14.5C12.8284 14.5 13.5 15.1716 13.5 16V17.5C13.5 18.3284 12.8284 19 12 19C11.1716 19 10.5 18.3284 10.5 17.5V16Z" fill="#343C54"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.75 7.25C6.75 4.3505 9.10051 2 12 2C14.8995 2 17.25 4.35051 17.25 7.25V9.125H18.5C19.7426 9.125 20.75 10.1324 20.75 11.375V17.2495C20.75 19.8729 18.6234 21.9995 16 21.9995H8C5.37665 21.9995 3.25 19.8729 3.25 17.2495V11.375C3.25 10.1324 4.25736 9.125 5.5 9.125H6.75V7.25ZM8.25 9.125H15.75V7.25C15.75 5.17893 14.0711 3.5 12 3.5C9.92893 3.5 8.25 5.17893 8.25 7.25V9.125ZM5.5 10.625C5.08579 10.625 4.75 10.9608 4.75 11.375V17.2495C4.75 19.0444 6.20507 20.4995 8 20.4995H16C17.7949 20.4995 19.25 19.0444 19.25 17.2495V11.375C19.25 10.9608 18.9142 10.625 18.5 10.625H5.5Z" fill="#343C54"/>
      </svg>
    `;
    return U.createHTMLElementFromString(div);
  },
  documentPlus() {
    const div = `
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
      <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m3.75 8.25v3.75m0 0v3.75m0-3.75h3.375m-9.75 0H12" />
    </svg>
    `;
    return U.createHTMLElementFromString(div);
  },
  documentText() {
    const div = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-10 h-10" aria-label="Text document">
      <path fill="none" stroke="#2563eb" stroke-width="1.5" stroke-linejoin="round" d="M8 2h8l4 4v14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z"/>
      <path fill="none" stroke="#2563eb" stroke-width="1.5" stroke-linejoin="round" d="M16 2v4h4"/>
      <text x="12" y="15.5" text-anchor="middle" font-size="6" font-weight="700" font-family="system-ui, sans-serif" fill="#2563eb">TXT</text>
    </svg>
    `;
    return U.createHTMLElementFromString(div);
  },
  documentPdf() {
    const div = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-10 h-10" aria-label="PDF document">
      <path fill="none" stroke="#dc2626" stroke-width="1.5" stroke-linejoin="round" d="M8 2h8l4 4v14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z"/>
      <path fill="none" stroke="#dc2626" stroke-width="1.5" stroke-linejoin="round" d="M16 2v4h4"/>
      <text x="12" y="15.5" text-anchor="middle" font-size="5.5" font-weight="700" font-family="system-ui, sans-serif" fill="#dc2626">PDF</text>
    </svg>
    `;
    return U.createHTMLElementFromString(div);
  },
  fileTypeIcon(fileType) {
    if (fileType === 'application/pdf') {
      return this.documentPdf();
    }
    if (fileType === 'text/plain') {
      return this.documentText();
    }
    return null;
  },
  pencilSquare() {
    const div = `
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
      <path stroke-linecap="round" stroke-linejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
    </svg>
    `;
    return U.createHTMLElementFromString(div);
  },
  clipboardDocument() {
    const div = `
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
      <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 7.5H6a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 6 22.5h7.5m-9-3H4.875c-.621 0-1.125-.504-1.125-1.125V18.75m8.25-8.25V18.75m0 0v-1.5c0-.621.504-1.125 1.125-1.125h3.75c.621 0 1.125.504 1.125 1.125V18.75m0 0h3.375c.621 0 1.125-.504 1.125-1.125v-5.25c0-.621-.504-1.125-1.125-1.125h-3.75c-.621 0-1.125.504-1.125 1.125v3.75m0 0H21m-8.25-3H10.5a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25h6.75a2.25 2.25 0 0 0 2.25-2.25V15a2.25 2.25 0 0 0-2.25-2.25h-1.5m-6.75 0H9" />
    </svg>
    `;
    return U.createHTMLElementFromString(div);
  },
  documentPencil() {
    const div = `
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
      <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m.75 12 3 3m0 0 3-3m-3 3v-8.25m-12 0V19.5a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 19.5v-4.875A2.25 2.25 0 0 0 19.5 12.375h-4.125a3.375 3.375 0 0 1-3.375-3.375V8.25m0 0H12" />
    </svg>
    `;
    return U.createHTMLElementFromString(div);
  },
  users() {
    const div = `
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
      <path stroke-linecap="round" stroke-linejoin="round" d="M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z" />
    </svg>
    `;
    return U.createHTMLElementFromString(div);
  },
  flag(size = 18, {outline = false} = {}) {
    if (outline) {
      const div = `
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.25" stroke="currentColor" width="${size}" height="${size}" aria-hidden="true" class="text-grey-dark">
        <circle cx="12" cy="12" r="10" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path stroke-linecap="round" stroke-linejoin="round" d="M10.75 7.25v9.5M10.75 7.25h5.75l-1.5 2.25 1.5 2.25H10.75" />
      </svg>
      `;
      return U.createHTMLElementFromString(div);
    }

    const div = `
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="${size}" height="${size}" aria-hidden="true" class="text-primary">
      <path stroke-linecap="round" stroke-linejoin="round" d="M3 3v18M8 3h9l-3 4 3 4H8" />
    </svg>
    `;
    return U.createHTMLElementFromString(div);
  },
  phone() {
    const div = `
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
      <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 6.75Z" />
    </svg>
    `;
    return U.createHTMLElementFromString(div);
  },
  personSpeech() {
    const div = `
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
      <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 7.5a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z" />
      <path stroke-linecap="round" stroke-linejoin="round" d="M1.5 19.5a4.875 4.875 0 0 1 9.75 0" />
      <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5h6.75A1.75 1.75 0 0 1 22 6.25v5a1.75 1.75 0 0 1-1.75 1.75h-1.65L16.5 15.5v-2.5h-3A1.75 1.75 0 0 1 11.75 11.25v-5A1.75 1.75 0 0 1 13.5 4.5Z" />
    </svg>
    `;
    return U.createHTMLElementFromString(div);
  },
  /** Envelope + check in circle badge (common “mail check” pattern — custom strokes, Heroicons-compatible style) */
  mailCheckBadge() {
    const div = `
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 comms-log-test-icon">
      <path stroke-linecap="round" stroke-linejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75" />
      <circle cx="17.85" cy="16.95" r="4.15" stroke-linecap="round" stroke-linejoin="round"/>
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m15.82 17.02 1.18 1.18 3.25-4.08" />
    </svg>
    `;
    return U.createHTMLElementFromString(div);
  },
};
